// extracted by mini-css-extract-plugin
module.exports = {"documents":"AutomatedFundsLiteratureAccordion_documents__7ytHf","link-icon":"AutomatedFundsLiteratureAccordion_link-icon__DYRwj"};